import { HTMLAttributes, PropsWithChildren } from 'react'
import { cn } from '../utils'

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  size?: string
}

export default function Tag({
  children,
  className,
  ...props
}: PropsWithChildren<TagProps>) {
  const classNames = cn([
    'text-xs',
    'rounded-[4px]',
    'mb-1',
    'px-1',
    'py-0.25',
    className
  ])

  return (
    <span className={classNames} {...props}>
      {children}
    </span>
  )
}
